export const EventConstants = {
    RDF_SEARCH_ICON_CLICKED: 'rdfSearchIconClicked'
}
